import api from './api'; // Import Axios instance

// POST request for creating a new NRT Order
export const getNrtOrder = async (orderId) => {
    try {
        const response = await api.get(`/nrt/order/${orderId}`);

        const order = response.data.payload; // Assuming the response contains the created order in 'payload'
        return order;

    } catch (error) {
        console.error("Error creating NRT order:", error);
    }
};

export const getUserOrderHistory = async (userId) => {
    try {
        const response = await api.get(`nrt/userOrders/${userId}`);
        const orderHistory = response.data.payload;
        return orderHistory;
    } catch (error) {
        console.error("No NRT Order History found:", error);
    }
}

export const createNrtOrder = async (orderData) => {
    try {
        const response = await api.post("/nrt/order", orderData, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const newNrtOrder = response.data.payload; // Assuming the response contains the created order in 'payload'
        return newNrtOrder;

    } catch (error) {
        console.error("Error creating NRT order:", error);
    }
};

// PATCH request for updating an existing NRT Order (unchanged from your previous code)
export const updateNrtOrder = async (patchData) => {
    try {
        const response = await api.patch("/nrt/order", patchData, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const updatedNrtOrder = response.data.payload;
        return updatedNrtOrder;

    } catch (error) {
        console.error("Error updating NRT order:", error);
    }
};

export const updateProductStock = async (products) => {
    try {
        const response = await api.post('/nrt/products/', products, {
            headers: {
                'Content-Type': 'application/json',
            }
        });

        return response.data.payload;
    } catch (error) {
        console.error('Failed to update Product list');
        throw error;
    }

};

export const getAllNrtProducts = async () => {
    try {
        const response = await api.get('/nrt/products/');
        const nrtProducts = response.data.payload;
        return nrtProducts;

    } catch (error) {
        console.error('Failed to get NRT Products list');
        throw error;
    }
};


export const getUserMedicalQuestionnaire = async (id) => {
    try {
        const response = await api.get(`/nrt/user/${id}/medical/`);
        const questions = response.data.payload;
        return questions;

    } catch (error) {
        //console.error('Failed to get user medical questionniare');
        //throw error;
        return null;
    }
};

export const getUserMedicalQuestionnaireHistory = async (id) => {
    try {
        const response = await api.get(`/nrt/user/${id}/medical/history`);
        return response.data.payload;

    } catch (error) {
        return null;
    }
};

export const getQuestionAnswersByUserId = async (id) => {
    try {
        const response = await api.get(`/question-answer/user/${id}/answers`);
        return response.data.payload;
    } catch (error) {
        //console.error('Failed to get user question answers:', error.payload);
        //throw error;
    }
};

export const getNRTOrders = async () => {
    try {
        const response = await api.get('/nrt/orders/');
        return response.data.payload;
    } catch (error) {
        //console.error('Error fetching NRT orders:', error.payload);
        //throw error;
    }
};

export const deleteNRTRecord = async (orderId) => {
    try {
        const response = await api.post('/nrt/delete/', orderId, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data.payload;
    } catch (error) {
        //console.error('Error deleting NRT order:', error.payload);
        //throw error;
    }
}